﻿import jquery from 'jquery';
import HabEvents from '../../../Global/habitaclia-events';
import HabUtils from '../../../Global/habitaclia-utils';
import accountUser from '../../../Desktop/modules/account-user';

class FavoritosService {

    constructor(favoritosRepository, favoritosDto) {
        this._favoritosRepository = favoritosRepository;
        this._isUserLogged = favoritosDto.UserIsLogged === 'True';
        this._pendingFavorito = null;
        this._registerEvents();
    }

    _registerEvents() {

        jquery.subscribe(HabEvents.EventsEnum.LoginAjaxOk, () => {
            this._isUserLogged = true;
        });
    }

    _getEvent(type) {
        return type === 'add' ? HabEvents.EventsEnum.FavoritoAnadido : HabEvents.EventsEnum.FavoritoEliminado;
    }

    _getActionEvent(type) {
        return type === 'add' ? HabEvents.EventsEnum.FavoritoAnadirAccion : HabEvents.EventsEnum.FavoritoEliminarAccion;
    }

    setFavorito(dataUrl, hasFavorito, codigoAnuncio, realEstateAdId) {
        const type = hasFavorito ? 'remove' : 'add';
        const favoritoData = HabUtils.GetQueryStringFromGivenURL(dataUrl);
        const actionEventType = this._getActionEvent(type);
        jquery.publish(actionEventType);
       
        if (this._isUserLogged) {
            return this._favoritosRepository
                .setFavorito(dataUrl, favoritoData, type)
                .then(({ type, data }) => {
                    const evenType = this._getEvent(type);
                    jquery.publish(evenType, [codigoAnuncio, realEstateAdId]);
                    return { type, data };
                }).catch((err) => {
                    console.log('Error en setFavorito', err);
                });
        } else {
            accountUser.ShowModalLogin('favorito');
            this._pendingFavorito = { dataUrl, favoritoData, codigoAnuncio }; 
            return Promise.reject('Show login');
        }
    }

    continueWithFavoritoPending() {

        this._isUserLogged = true;

        if (this._pendingFavorito) {
            const codigo = this._pendingFavorito.codigoAnuncio;

            return this._favoritosRepository
                .setFavorito(this._pendingFavorito.dataUrl, this._pendingFavorito.favoritoData, 'add')
                .then(({ type, data }) => {
                    jquery.publish(this._getEvent(type), [codigo]);
                    this._pendingFavorito = null;
                    return { codigoAnuncio: codigo, type, data};
                });
        }
    }

    saveRate(idReg, rate) {

        const rateData = {
            idReg,
            rate
        };

        return this._favoritosRepository.saveRate(rateData);

    }

    saveComment(idReg, comment) {

        const commentData = {
            IdReg: idReg,
            Comment: comment
        };

        return this._favoritosRepository.saveComment(commentData);
    }
}

export default FavoritosService;